'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../styles/templates/product.scss');

require('../sections/template-product');

require('../sections/template-product-related');

require('../sections/index-blog');

(0, _themeSections.load)(['template-product', 'template-product-related', 'index-blog']);

// Product sections